module.exports = __webpack_public_path__ + "img/c00_buildingtechclosecombatexpertise_Normal_ua.2c66ba71.webp";